import Vue from 'vue'
import VueRouter from 'vue-router'
// import Store from '../store' 
// import Cookies from 'js-cookie'
// import Home from '../views/Home.vue'

// const unionRegist = () => import('../views/unionRegist.vue')
const extension = () => import('../views/extension.vue')
const linkInvitations = () => import('../views/linkInvitations.vue')
const qrInvitation = () => import('../views/qrInvitation.vue')
const register = () => import('../views/register.vue')
const download = () => import('../views/download.vue')
const download2 = () => import('../views/download2.vue')
const cooperation = () => import('../views/cooperation.vue')
const record = () => import('../views/record.vue')
const myFriend = () => import('../views/myFriend.vue')
const searchFriend = () => import('../views/searchFriend.vue')
const html = () => import('../views/html.vue')
// unionRegist

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/unionRegist',
  //   name: 'unionRegist',
  //   title: '联盟注册',
  //   component: unionRegist
  // },
  {
    path: '/',
    name: 'extension',
    title: '邀请好友',
    component: extension
  },
  {
    path: '/register',
    name: 'register',
    title: '邀请注册',
    meta: {
      title: '邀请注册'
    },
    component: register
  },
  {
    path: '/linkInvitations',
    name: 'linkInvitations',
    title: '链接邀请',
    component: linkInvitations
  },
  {
    path: '/qrInvitation',
    name: 'qrInvitation',
    title: '二维码邀请',
    component: qrInvitation
  },
  {
    path: '/download',
    name: 'download',
    title: '下载',
    component: download
  },
  {
    path: '/download2',
    name: 'download2',
    title: '下载',
    component: download2
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    title: '大渠道合作',
    component: cooperation
  },
  {
    path: '/record',
    name: 'record',
    title: '阶梯奖励',
    component: record
  },
  {
    path: '/myFriend',
    name: 'myFriend',
    title: '我的好友',
    component: myFriend
  },
  {
    path: '/searchFriend',
    name: 'searchFriend',
    title: '搜索好友',
    component: searchFriend
  },
  {
    path: '/html',
    name: 'html',
    title: 'html',
    component: html
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(from)
  // // eslint-disable-next-line no-debugger
  // debugger
  if (to.query.token) {
    sessionStorage.setItem('token', `Bearer ${to.query.token}`)
  } else if(from.query.token) {
    sessionStorage.setItem('token', `Bearer ${from.query.token}`)
  }
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '赚钱了'
  }
  next()
})

export default router
